import ImageEditor from '@uppy/image-editor';
import GifCropper from './GifCropper';

export default class EnhancedImageEditor extends ImageEditor {
  save = () => {
    const { uppy } = this;
    const loadingStatus = this.#loadingStatus;
    loadingStatus?.show();

    const saveBlobCallback = async (blob) => {
      const { currentImage } = this.getPluginState();

      uppy.setFileState(currentImage.id, {
        data: blob,
        size: blob.size,
        preview: null,
      });

      const updatedFile = uppy.getFile(currentImage.id);
      uppy.emit('thumbnail:request', updatedFile);
      this.setPluginState({
        currentImage: updatedFile,
      });
      uppy.emit('file-editor:complete', updatedFile);
      loadingStatus?.hide();
    };

    const errorCallback = (code, error) => {
      uppy.log(`[EnhancedImageEdtior] ${code}: ${error.message}, ${error.stack}`, 'error');
      uppy.info('Error cropping gif file', 'error');
      // When an error happens, gif cropping is skipped.
      // We can additionally remove the file which will reset the uploader to the initial screen.

      // const { currentImage } = this.getPluginState();
      // uppy.removeFile(currentImage.id);
      loadingStatus?.hide();
    };

    const { currentImage } = this.getPluginState();

    if (currentImage.type === 'image/gif') {
      const url = URL.createObjectURL(currentImage.data);

      const gifCropper = new GifCropper({
        src: url,
        encoder: {
          workers: 2,
          quality: 10,
        },
        onError: errorCallback,
      });

      gifCropper.crop(this.cropper, saveBlobCallback);
    } else {
      this.cropper.getCroppedCanvas(this.opts.cropperOptions.croppedCanvasOptions).toBlob(
        saveBlobCallback,
        currentImage.type,
        this.opts.quality,
      );
    }
  };

  get #loadingStatus() {
    return this.uppy.getPlugin('LoadingStatus');
  }
}
